import endpoint from 'config/endpoint'
import { getRequestHeaders } from 'routes/Menu/apis/_utils'
import { fetchRaw } from 'utils/fetch'

const options = {
  method: 'GET',
  cache: 'default',
  headers: {},
  timeout: null,
  includeCookies: false,
  useMenuService: true,
}

const getTasteProfileIdFromQuery = (query) => {
  if (query && query.tasteProfileId) {
    return query.tasteProfileId
  }

  return null
}

const constructURL = (endpointVersion, date, isAdminQuery = false) => {
  if (isAdminQuery || endpointVersion === 1) {
    return `${endpoint('menu', endpointVersion)}/menus`
  }

  return `${endpoint('menu', endpointVersion)}/menus${date ? '' : '/current'}`
}

export function fetchMenus(accessToken, query, { date, endpointVersion = 1 } = {}) {
  const fetchOptions = {
    ...options,
    accessToken,
    headers: {
      ...options.headers,
      ...getRequestHeaders(),
    },
  }

  let adminLinkData
  const isAdminQuery = query && query['preview[auth_user_id]']
  if (isAdminQuery) {
    adminLinkData = {
      'preview[menu_id]': query['preview[menu_id]'],
      'preview[auth_user_id]': query['preview[auth_user_id]'],
      'preview[expiry]': query['preview[expiry]'],
      'preview[signature]': query['preview[signature]'],
    }
  }

  const requestQueryParams = {
    include: 'ingredients',
    addAlternatives: true,
    ...adminLinkData,
  }

  const tasteProfileId = getTasteProfileIdFromQuery(query)

  if (tasteProfileId) {
    requestQueryParams.tasteProfileId = tasteProfileId
  }

  // requestQueryParams.forceSwapsExperimentUserAllocationGroup = 'variant-b'
  if (endpointVersion === 2 && date) {
    requestQueryParams.date = date
  }

  const url = constructURL(endpointVersion, date, isAdminQuery)

  return fetchRaw(url, requestQueryParams, fetchOptions)
}

export function fetchMenusWithUserId(
  accessToken,
  query,
  userId,
  { date, endpointVersion = 1 } = {},
) {
  const fetchOptions = {
    ...options,
    accessToken,
    headers: {
      ...options.headers,
      ...getRequestHeaders(userId),
    },
  }

  const requestQueryParams = {
    include: 'ingredients',
    addAlternatives: true,
    userId,
  }

  const tasteProfileId = getTasteProfileIdFromQuery(query)

  if (tasteProfileId) {
    requestQueryParams.tasteProfileId = tasteProfileId
  }

  if (endpointVersion === 2 && date) {
    requestQueryParams.date = date
  }

  const url = constructURL(endpointVersion, date)

  return fetchRaw(url, requestQueryParams, fetchOptions)
}

export function fetchSimpleMenu(accessToken, userId) {
  const fetchOptions = {
    ...options,
    accessToken,
    headers: {
      ...options.headers,
      ...getRequestHeaders(userId),
    },
  }

  const requestQueryParams = {
    includeMenuRelationships: false,
    userId,
  }

  return fetchRaw(`${endpoint('menu')}/menus`, requestQueryParams, fetchOptions)
}
